import * as React from 'react'

import './TimelineCard.css'

import {Card, ICardProps} from './Card'

import TimeInput from './TimeInput';
import IModalOpenableProps from '../Modal/IModalOpenableProps'
import { ToolInstance } from '../ToolInstance';

export interface ITimelineCardProps extends ICardProps, IModalOpenableProps {
    toolInstance: ToolInstance;
    defaultTime: number;
    dragActive: boolean;
}

interface ITimelineCardState {
    isFocused: boolean;
}

class TimelineCard extends Card<ITimelineCardProps, ITimelineCardState> {
    public constructor(props: ITimelineCardProps) {
        super(props);

        this.state = {
            isFocused: false
        };
    }

    public render() {
        const mouseDownedPrepped = this.mouseDowned.bind(this);
        const mouseUppedPrepped = this.mouseUpped.bind(this);
        const mouseMovedPrepped = this.mouseMoved.bind(this);
        const mouseLeftPrepped = this.mouseLeft.bind(this);

        return (
            <div className={
                "TimelineCard "
                    + this
                    .getClassModifiers()
                    .map<string>(modifier => "TimelineCard--"+modifier)
                    .join(" ")
                }

                onMouseDown={mouseDownedPrepped}
                onMouseUp={mouseUppedPrepped}
                onMouseMove={mouseMovedPrepped}
                onMouseLeave={mouseLeftPrepped}

                ref={this.getCardRef()}
                >

                <div className="TimelineCard__name-box" onClick={this.clicked}>
                    <span>{this.props.name}</span>
                </div>

                <div className="TimelineCard__time-box">
                    <TimeInput
                        className={"TimelineCard__time-input" + (this.state.isFocused ? "" : " TimelineCard__time-input--inactive")}
                        time={this.props.toolInstance!.time}

                        onFocus={this.focused}
                        onBlur={this.blurred}
                        onChange={this.timeInputChanged}
                        />
                </div>
            </div>
        );
    }

    protected getClassModifiers() : string[] {
        return this.props.dragActive ? [ "drag-active" ] : [];
    }

    private focused = (event: React.FocusEvent) => {
        this.setState({
            isFocused: true
        });
    };

    private blurred = (event: React.FocusEvent) => {
        this.setState({
            isFocused: false
        });
    };

    private timeInputChanged = (newValue: number | string) : void => {
        this.props.toolInstance.setTime(newValue);
    };

    private clicked = (event: React.MouseEvent) => {
        this.props.openModal(this.props.toolInstance);
    };
}

export default TimelineCard;



// WEBPACK FOOTER //
// ./src/App/Elements/TimelineCard.tsx